import { Loader, TextInput, TextInputProps } from '@mantine/core';
import { FC, useRef, useState } from 'react';

interface Props extends TextInputProps {
  onBlurSave: (val: string) => Promise<boolean>;
  validate?: (val: string) => boolean;
  errorMessage?: string;
}

const BookitupTextInput: FC<Props> = ({ onBlurSave, validate, errorMessage, ...rest }) => {
  const [updating, setUpdating] = useState(false);
  const ref = useRef<HTMLInputElement>(null);

  // eslint-disable-next-line no-underscore-dangle
  const _onBlur = async (val: string) => {
    setUpdating(true);
    await onBlurSave(val);
    setUpdating(false);
  };

  const getErrorNode = () => {
    const { value } = ref.current ?? { value: null };
    if (!value || !validate) return null;
    if (validate(value)) return null;
    return errorMessage ?? 'Upps etwas ist schief gelaufen';
  };

  return (
    <TextInput
      ref={ref}
      rightSection={updating && <Loader size="xs" />}
      onBlur={(e) => _onBlur(e.currentTarget.value)}
      error={getErrorNode()}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
    />
  );
};

export default BookitupTextInput;
